import Icon from '../components/common/icon/Icon';
import SvgIcon from '../components/common/svgicon/SvgIcon';

export const ICON_TYPE = {
  LINEAR: 'linear',
  SVG: 'svg'
};

export const ICON_COMPONENT = {
  linear: Icon,
  svg: SvgIcon
};



// WEBPACK FOOTER //
// ./src/constants/icons.js